export const categories = [
  { id: 'romance', name: '浪漫爱情', icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事，感受心动瞬间' },
  { id: 'fantasy', name: '奇幻冒险', icon: 'ri-rocket-line', description: '奇幻世界冒险旅程，激发无限想象' },
  { id: 'action', name: '热血动作', icon: 'ri-fire-line', description: '激烈战斗与热血对决，燃爆每一页' },
  { id: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line', description: '轻松幽默的日常趣事，开怀大笑' },
  { id: 'thriller', name: '悬疑惊悚', icon: 'ri-ghost-line', description: '扣人心弦的悬疑故事，层层反转' },
  { id: 'drama', name: '都市剧情', icon: 'ri-building-line', description: '现代都市生活百态，情感共鸣' },
  { id: 'historical', name: '古风历史', icon: 'ri-ancient-gate-line', description: '穿越古代的历史传奇，唯美画风' },
  { id: 'bl', name: 'BL系列', icon: 'ri-user-heart-line', description: '人气BL漫画作品，甜蜜互动' },
];

export const featuredComics = [
  {
    id: 1,
    title: '她的秘密花园',
    category: 'romance',
    author: '金智秀',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20manhwa%20cover%20art%20style%2C%20young%20couple%20in%20a%20garden%20with%20cherry%20blossoms%2C%20soft%20pastel%20colors%2C%20watercolor%20texture%2C%20clean%20white%20background%2C%20elegant%20composition%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '一个关于秘密与爱情的治愈故事，当两个人的世界意外交织，一切都变得不同...',
    rating: 9.5,
    views: 128000,
    isNew: false,
    isHot: true,
    chapters: 86,
    updateDate: '2026-08-04',
  },
  {
    id: 2,
    title: '暗影猎手',
    category: 'action',
    author: '朴在贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20action%20Korean%20manhwa%20cover%20art%2C%20mysterious%20hunter%20with%20sword%20in%20shadow%2C%20dramatic%20lighting%2C%20dark%20toned%20illustration%2C%20clean%20white%20background%2C%20Korean%20webtoon%20aesthetic%2C%20dynamic%20pose&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '在黑暗的世界里，一群猎手守护着人类最后的希望。史诗级动作漫画...',
    rating: 9.3,
    views: 256000,
    isNew: false,
    isHot: true,
    chapters: 124,
    updateDate: '2026-08-03',
  },
  {
    id: 3,
    title: '魔法学院日常',
    category: 'fantasy',
    author: '李美娜',
    cover: 'https://readdy.ai/api/search-image?query=A%20colorful%20fantasy%20Korean%20manhwa%20cover%2C%20magic%20academy%20students%20with%20sparkling%20wands%2C%20bright%20vibrant%20colors%2C%20mystical%20atmosphere%2C%20clean%20white%20background%2C%20Korean%20webtoon%20aesthetic%2C%20cheerful%20mood&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '普通高中生意外进入魔法学院，从此展开了一段不可思议的冒险...',
    rating: 9.1,
    views: 98000,
    isNew: true,
    isHot: true,
    chapters: 52,
    updateDate: '2026-08-05',
  },
  {
    id: 4,
    title: '办公室罗曼史',
    category: 'romance',
    author: '郑秀晶',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20office%20setting%20Korean%20manhwa%20cover%2C%20handsome%20man%20and%20beautiful%20woman%20in%20modern%20office%2C%20warm%20lighting%2C%20soft%20colors%2C%20clean%20white%20background%2C%20Korean%20webtoon%20aesthetic%2C%20elegant%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '职场新人与严厉上司之间悄然滋生的感情，甜到让人心跳加速...',
    rating: 9.4,
    views: 185000,
    isNew: false,
    isHot: false,
    chapters: 68,
    updateDate: '2026-08-01',
  },
  {
    id: 5,
    title: '午夜追踪者',
    category: 'thriller',
    author: '姜东元',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20thriller%20Korean%20manhwa%20cover%20art%2C%20detective%20in%20dark%20alley%20with%20flashlight%2C%20noir%20atmosphere%2C%20moody%20blue%20tones%2C%20clean%20white%20background%2C%20Korean%20webtoon%20aesthetic%2C%20suspenseful%20mood&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '深夜城市中的连环案件，一位私家侦探踏上追寻真相的危险之路...',
    rating: 9.0,
    views: 76000,
    isNew: true,
    isHot: false,
    chapters: 34,
    updateDate: '2026-08-05',
  },
  {
    id: 6,
    title: '爆笑便利店',
    category: 'comedy',
    author: '崔志浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20comedy%20Korean%20manhwa%20cover%2C%20quirky%20convenience%20store%20workers%2C%20bright%20colorful%20illustration%2C%20cartoonish%20expressions%2C%20clean%20white%20background%2C%20Korean%20webtoon%20aesthetic%2C%20humorous%20tone&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '便利店里形形色色的顾客和店员们，每天都有让人捧腹大笑的故事...',
    rating: 8.9,
    views: 142000,
    isNew: false,
    isHot: true,
    chapters: 98,
    updateDate: '2026-07-30',
  },
  {
    id: 7,
    title: '时光之书',
    category: 'historical',
    author: '尹恩惠',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20historical%20Korean%20manhwa%20cover%2C%20traditional%20hanbok%20clothing%20characters%20in%20ancient%20palace%20setting%2C%20elegant%20soft%20brush%20painting%20style%2C%20warm%20earthy%20tones%2C%20clean%20white%20background%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '一本神秘的古老书籍，带领现代女孩穿越回朝鲜时代，展开绝美爱恋...',
    rating: 9.6,
    views: 310000,
    isNew: false,
    isHot: true,
    chapters: 142,
    updateDate: '2026-08-04',
  },
  {
    id: 8,
    title: '城市之光',
    category: 'drama',
    author: '韩智慧',
    cover: 'https://readdy.ai/api/search-image?query=A%20modern%20drama%20Korean%20manhwa%20cover%2C%20young%20professionals%20in%20Seoul%20cityscape%2C%20warm%20sunset%20lighting%2C%20sophisticated%20illustration%2C%20clean%20white%20background%2C%20Korean%20webtoon%20aesthetic%2C%20emotional%20depth&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '首尔都市中五个年轻人的梦想与挣扎，关于成长、友情和选择的温暖故事...',
    rating: 9.2,
    views: 89000,
    isNew: true,
    isHot: false,
    chapters: 41,
    updateDate: '2026-08-05',
  },
];

export const latestUpdates = [
  {
    id: 9,
    title: '星光奏鸣曲',
    category: 'romance',
    author: '金泰妍',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20music%20themed%20Korean%20manhwa%20cover%2C%20pianist%20couple%20under%20starlight%2C%20dreamy%20atmosphere%2C%20soft%20blue%20and%20gold%20tones%2C%20clean%20white%20background%2C%20Korean%20webtoon%20aesthetic&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    rating: 9.0,
    chapters: 28,
    updateDate: '2026-08-05',
    isNew: true,
    isHot: false,
  },
  {
    id: 10,
    title: '异世界餐厅',
    category: 'fantasy',
    author: '李敏镐',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20food%20themed%20Korean%20manhwa%20cover%2C%20magical%20restaurant%20chef%20cooking%2C%20warm%20delicious%20illustration%2C%20rich%20colors%2C%20clean%20white%20background%2C%20Korean%20webtoon%20aesthetic%2C%20cozy%20vibe&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    rating: 8.8,
    chapters: 36,
    updateDate: '2026-08-04',
    isNew: true,
    isHot: false,
  },
  {
    id: 11,
    title: '拳霸天下',
    category: 'action',
    author: '宋康昊',
    cover: 'https://readdy.ai/api/search-image?query=An%20intense%20martial%20arts%20Korean%20manhwa%20cover%2C%20fighter%20in%20dynamic%20action%20pose%2C%20powerful%20energy%2C%20bold%20red%20accents%2C%20clean%20white%20background%2C%20Korean%20webtoon%20aesthetic%2C%20fighting%20spirit&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    rating: 9.1,
    chapters: 56,
    updateDate: '2026-08-05',
    isNew: false,
    isHot: true,
  },
  {
    id: 12,
    title: '我们之间',
    category: 'bl',
    author: '金宇彬',
    cover: 'https://readdy.ai/api/search-image?query=A%20gentle%20tender%20Korean%20BL%20manhwa%20cover%2C%20two%20young%20men%20sharing%20a%20quiet%20moment%2C%20soft%20pastel%20colors%2C%20emotional%20expression%2C%20clean%20white%20background%2C%20Korean%20webtoon%20aesthetic%2C%20romantic%20atmosphere&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    rating: 9.3,
    chapters: 44,
    updateDate: '2026-08-03',
    isNew: false,
    isHot: true,
  },
  {
    id: 13,
    title: '幽灵教室',
    category: 'thriller',
    author: '全智贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20spooky%20school%20themed%20Korean%20manhwa%20cover%2C%20students%20in%20haunted%20classroom%2C%20eerie%20atmosphere%2C%20cold%20tones%2C%20clean%20white%20background%2C%20Korean%20webtoon%20aesthetic%2C%20mysterious%20mood&width=400&height=560&seq=comic-cover-13&orientation=portrait',
    rating: 8.7,
    chapters: 22,
    updateDate: '2026-08-05',
    isNew: true,
    isHot: false,
  },
  {
    id: 14,
    title: '花路',
    category: 'drama',
    author: '刘亚仁',
    cover: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20drama%20Korean%20manhwa%20cover%2C%20flower%20shop%20owner%20with%20blooming%20flowers%2C%20warm%20sunlight%2C%20gentle%20illustration%2C%20clean%20white%20background%2C%20Korean%20webtoon%20aesthetic%2C%20peaceful%20mood&width=400&height=560&seq=comic-cover-14&orientation=portrait',
    rating: 9.4,
    chapters: 72,
    updateDate: '2026-08-02',
    isNew: false,
    isHot: true,
  },
];

export const faqData = [
  {
    question: '韩漫之家是什么？',
    answer: '韩漫之家是一个专注于高清韩国漫画免费在线阅读的平台，汇集了各类韩国优秀漫画作品，包括浪漫爱情、奇幻冒险、热血动作等多种类型，为广大韩漫爱好者提供优质的阅读体验。',
  },
  {
    question: '如何查找特定类型的漫画？',
    answer: '您可以通过首页的分类导航或顶部的分类菜单，按类型筛选漫画。我们提供浪漫爱情、奇幻冒险、热血动作、搞笑日常、悬疑惊悚、都市剧情、古风历史和BL系列等多种分类，方便您快速找到感兴趣的作品。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '我们与多家韩国漫画平台保持合作，确保漫画更新及时。大部分热门作品每周更新1-2话，新作品上线后也会在第一时间同步更新。您可以在首页的"最新更新"区域查看最近更新的作品。',
  },
  {
    question: '需要注册账号才能阅读吗？',
    answer: '目前韩漫之家完全免费开放阅读，无需注册账号即可浏览所有漫画内容。我们致力于为读者提供最简单便捷的阅读体验，让您随时随地畅享韩漫的精彩世界。',
  },
  {
    question: '支持手机阅读吗？',
    answer: '韩漫之家采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您使用什么设备访问，都能获得流畅舒适的阅读体验，随时随地畅读高清韩国漫画。',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小美',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20woman%20portrait%2C%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20simple%20background%2C%20professional%20headshot%20style%2C%20friendly%20expression&width=100&height=100&seq=avatar-01&orientation=squarish',
    comment: '自从发现了韩漫之家，我每天都要上来追更新！分类特别全，画质也很清晰，推荐给了好多朋友。',
    rating: 5,
  },
  {
    id: 2,
    name: '动漫达人阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20man%20portrait%2C%20casual%20friendly%20look%2C%20soft%20natural%20lighting%2C%20clean%20simple%20background%2C%20professional%20headshot%20style%2C%20confident%20expression&width=100&height=100&seq=avatar-02&orientation=squarish',
    comment: '作为资深韩漫迷，这个网站真的让我惊喜。更新速度很快，界面也很清爽，阅读体验一流！',
    rating: 5,
  },
  {
    id: 3,
    name: '书虫小琳',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20woman%20portrait%2C%20gentle%20smile%2C%20soft%20natural%20lighting%2C%20clean%20simple%20background%2C%20professional%20headshot%20style%2C%20warm%20expression&width=100&height=100&seq=avatar-03&orientation=squarish',
    comment: '韩漫之家的分类做得特别好，很容易找到喜欢的类型。而且免注册就能看，这点太棒了！',
    rating: 5,
  },
];

export const siteInfo = {
  name: '韩漫之家',
  description: '韩漫之家是国内领先的高清韩国漫画在线阅读平台，致力于为中文读者提供最全面、最优质的韩漫阅读体验。我们收录了大量热门韩国漫画作品，涵盖爱情、奇幻、动作、搞笑、悬疑等多种类型。',
  founded: '2020年',
  comics: '2000+',
  users: '500万+',
  email: 'contact@xxiut.cn',
  wechat: 'hanmanzhijia',
  weibo: '@韩漫之家官方',
};